import {ColDef, ColGroupDef} from 'ag-grid-community'
import {FC, useCallback, useEffect, useMemo, useState} from 'react'
import {callSP} from '../../../../setup/axios/AxiosCallSP'
import {AgGridTable} from '../../../utils/agGridTable/AgGridTable'
import {propsInterfaceFormGroupInput} from '../../../utils/form/FormGroupInput'
import {Loading} from '../../../utils/loadingR/Loading'
import {AlertModal, AlertModalProps} from '../../../utils/modal/AlertModal'
import {ModalForm} from '../../../utils/modal/ModalForm'
import {getColumGridService, getInputService, saveData, updateData} from './Maintainer.service'
import ReactTooltip from 'react-tooltip'
import * as Yup from 'yup'
import {Button} from 'react-bootstrap'
import {utils, writeFileXLSX} from 'xlsx'
import Template from 'app/shared/Template/Template'

const Maintainer: FC = () => {
  const styleInput = {width: '99%'}
  const [dataColumn, setDataColumn] = useState<(ColDef | ColGroupDef)[]>([])
  const [alertModal, setAlertModal] = useState<AlertModalProps | undefined>(undefined)
  const [showModalMenu, setShowModalMenu] = useState(false)
  const [gridRef, setGridRef] = useState<any>()
  const [recetaCeco, setRecetaCeco] = useState<any>()
  const [inputs, setInputs] = useState<propsInterfaceFormGroupInput[] | [] | undefined>([])
  const [initValue, setInitValues] = useState<any>({
    sitio: [],
    receta: [],
    tipo: [],
  })
  const [load, setLoad] = useState(false)

  const edit = useCallback((params) => {
    const {id, TIPO, id_receta, id_sitio, cli_nombre, id_tipo, rec_nombre} = params.data
    setInitValues({
      id,
      sitio: [{text: cli_nombre, value: id_sitio}],
      receta: [{text: rec_nombre, value: id_receta}],
      tipo: [{text: TIPO, value: id_tipo}],
    })
    setShowModalMenu(true)
  }, [])

  const dataSelected = useCallback((params) => {
    const {id} = params.data
    setAlertModal({
      message: '¿Esta seguro de eliminar?',
      title: 'Confirmación',
      save: async () => {
        const response = await callSP('amd_deleteTable', [
          {text: 'tabla', value: 'amd_recetas_sitio'},
          {text: 'id', value: id.toString()},
          {text: 'idN', value: 'id'},
        ])
        setAlertModal(undefined)
        getDataGrid()
      },
    })
  }, [])

  const getInputs = useCallback(
    (selectSitios, selectTipoReceta, setLoad, setInputs) => {
      setInputs(getInputService(selectSitios, selectTipoReceta, setLoad, setInputs))
    },
    [load]
  )

  const handleExportExcel = () => {
    const recetaCecoArray = recetaCeco || [];
    const recetaCecooMap = recetaCecoArray.map(
      ({id, cli_nombre, id_receta, id_sitio, rec_nombre, TIPO}: any) => ({
        Id: id,
        'Id Sitio': id_sitio,
        Sitio: cli_nombre,
        'Id Receta': id_receta,
        Receta: rec_nombre,
        Tipo: TIPO,
      })
    );

    const workbook = utils.book_new();
    const worksheet = utils.json_to_sheet(recetaCecooMap);
    const colWidth: any[] = [
      { wch: 7 },
      { wch: 10 },
      { wch: 35 },
      { wch: 10 },
      { wch: 60 },
    ];
    worksheet["!cols"] = colWidth;

    utils.book_append_sheet(workbook, worksheet, 'recetas-bloqueadas');
    writeFileXLSX(workbook, 'recetas-bloqueadas.xlsx');
  };

  const getDataGrid = async () => {
    const [dataReceta, selectSitios, selectTipoReceta] = await Promise.all([
      callSP('amd_getRecetasByCecoTipo', [{text: 'ceco', value: '0'}]),
      callSP('amd_getSitio', []),
      callSP('amd_getSelectTipo', [{text: 'tipo', value: 'TIPO_RECETA'}]),
    ])

    const dataC = getColumGridService()
    getInputs(selectSitios.data.result, selectTipoReceta.data.result, setLoad, setInputs)
    dataC.push(
      {
        headerName: 'Editar',
        cellRenderer: (params: any) => {
          return (
            <>
              <i
                data-tag='allowRowEvents'
                data-action={`edit-${params.id}`}
                data-tip
                data-for={`edit-${params.id}`}
                style={{cursor: 'pointer'}}
                onClick={() => {
                  return edit(params)
                }}
                className='bi bi-pencil-square'
              ></i>
              <ReactTooltip id={`edit-${params.id}`} place='left' type='success' effect='solid'>
                Editar receta bloqueada
              </ReactTooltip>
            </>
          )
        },
      },
      {
        headerName: 'Eliminar',
        cellRenderer: (params: any) => {
          return (
            <>
              <i
                data-tag='allowRowEvents'
                data-action={`delete-${params.id}`}
                data-tip
                data-for={`delete-${params.id}`}
                style={{cursor: 'pointer', color: 'red'}}
                onClick={() => {
                  return dataSelected(params)
                }}
                className='bi bi-trash-fill'
              ></i>
              <ReactTooltip id={`delete-${params.id}`} place='left' type='success' effect='solid'>
                Eliminar receta bloqueada
              </ReactTooltip>
            </>
          )
        },
      }
    )
    setDataColumn(dataC)
    setRecetaCeco(dataReceta.data.result)
  }

  useMemo(() => {
    getDataGrid()
  }, [])

  const addUser = useCallback(
    (_value) => {
      const {sitio, receta, tipo} = _value
      saveData(sitio[0].value, receta[0].value, tipo[0].value, getDataGrid)
    },
    [gridRef]
  )

  const validationSchema = Yup.object().shape({
    sitio: Yup.array().validateArray(),
    receta: Yup.array().validateArray(),
    tipo: Yup.array().validateArray(),
  })

  const handleSubmit = useCallback((_value: any) => {
    if (_value?.id) {
      updateData(_value, getDataGrid, setShowModalMenu, setLoad)
      return
    }
    saveData(_value, getDataGrid, setShowModalMenu, setLoad)
  }, [])

  return (
    <Template title='Recetas Bloqueadas'>
      <Loading open={load} />
      <div className='d-flex align-items-center'>
        <Button
          className='btn btn-primary'
          variant=''
          data-tag='allowRowEvents'
          data-action='delete'
          onClick={() => handleExportExcel()} //gridRef.current.api.exportDataAsCsv()}
        >
          Descargar Excel
        </Button>

        <i
          data-tag='allowRowEvents'
          data-action='plus'
          data-tip
          data-for='plus'
          style={{cursor: 'pointer'}}
          onClick={() => {
            setInitValues({
              sitio: [],
              receta: [],
              tipo: [],
            })
            setShowModalMenu(true)
          }}
          className='bi bi-plus-square'
        ></i>
        <ReactTooltip id='plus' place='right' type='success' effect='solid'>
          Agregar receta bloqueada
        </ReactTooltip>
      </div>

      <AgGridTable dataRow={recetaCeco} columnDefs={dataColumn} setAGGridRef={setGridRef} />

      {alertModal !== undefined && (
        <AlertModal
          message={alertModal?.message}
          show={alertModal?.message !== undefined}
          title={alertModal?.title}
          close={() => {
            setAlertModal(undefined)
          }}
          save={alertModal.save}
        />
      )}

      {showModalMenu && (
        <ModalForm
          initialValues={initValue}
          validationSchema={validationSchema}
          show={showModalMenu}
          onSubmit={handleSubmit}
          close={() => {
            setShowModalMenu(false)
          }}
          arrayInput={inputs}
          title={'Agregar a grilla'}
          modalFullscreen={false}
        />
      )}
    </Template>
  )
}
export {Maintainer}
